import { render, staticRenderFns } from "./AnunciosGenerales.vue?vue&type=template&id=1a2f9217&"
import script from "./AnunciosGenerales.vue?vue&type=script&lang=js&"
export * from "./AnunciosGenerales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Cwmm/JFwebsites__www.cwmm.local__web/private/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2f9217')) {
      api.createRecord('1a2f9217', component.options)
    } else {
      api.reload('1a2f9217', component.options)
    }
    module.hot.accept("./AnunciosGenerales.vue?vue&type=template&id=1a2f9217&", function () {
      api.rerender('1a2f9217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/AnunciosGenerales.vue"
export default component.exports